var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgBookmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.125 5.25C4.125 4.21447 4.96447 3.375 6 3.375H18C19.0355 3.375 19.875 4.21447 19.875 5.25V18.382C19.875 20.0053 17.9523 20.8616 16.7457 19.7756L12.2509 15.7303C12.1082 15.6019 11.8918 15.6019 11.7491 15.7303L7.25431 19.7756C6.04771 20.8616 4.125 20.0053 4.125 18.382V5.25ZM6 4.125C5.37868 4.125 4.875 4.62868 4.875 5.25V18.382C4.875 19.3559 6.02862 19.8697 6.75259 19.2182L11.2474 15.1728C11.6753 14.7878 12.3247 14.7878 12.7526 15.1728L17.2474 19.2182C17.9714 19.8697 19.125 19.3559 19.125 18.382V5.25C19.125 4.62868 18.6213 4.125 18 4.125H6Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgBookmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bookmark.d7ae36fcbafca830c579d7fac8a94170.svg";